module.exports = __webpack_public_path__ + "static/media/rating_2.1b9cc92b.svg";